<div class="dropdown" [ngClass]="{ 'dropdown-disabled': disabled }">
    <div class="title" (click)="toggleItems()" [attr.data-e2e-hook]="e2eHook">
        <span class="title-text">{{ title }}</span>
        <div class="caret-container">
            <div class="caret-down" [hidden]="displayItems"></div>
            <div class="caret-up" [hidden]="!displayItems"></div>
        </div>
    </div>
    <div class="items" [hidden]="!displayItems">
        <ul class="items-list">
            <li
                *ngFor="let item of items; let i = index"
                class="item"
                [ngClass]="{ 'item-with-icon': showIcon }"
                (click)="selectItem(item)"
                [attr.data-e2e-hook]="e2eHook + 'item' + i"
            >
                <span class="item-text" [ngClass]="{ 'item-text-selected': isSelected(item.text) }">
                    {{ item.text }}
                </span>
                <i *ngIf="showIcon && item.icon" class="{{ item.icon }}"></i>
            </li>
        </ul>
    </div>
</div>
